"use client"

import { FacetElementData } from "@/lib/factfinder/factfinder-interfaces"
import { getLinkWithEncryptedFfSearchParams } from "@/lib/link-utils/link-utils"
import { Category } from "@/lib/storefront/category/category"
import { cn } from "@/lib/utils"
import StoryblokAssetClient from "@/components/storyblok/common/StoryblokAssetClient"
import { formatFacetElementLabel } from "@/components/search-and-category/facet-label"
import { AssetStoryblok } from "@/components/storyblok/component-types"

interface CustomBadgeFacetElementProps {
  facetElementData: FacetElementData
  query?: string
  baseCategory?: Category
  allFacetElements: FacetElementData[] | undefined
  isoLocale: string
  sbLocale?: string
  brandSlug?: string
  unit?: string
  icon?: AssetStoryblok
  handleSelect: (allElemData: FacetElementData[] | undefined, currentElemData: FacetElementData, link: string) => void
}

export default function CustomBadgeFacetElement(props: CustomBadgeFacetElementProps) {
  const elementname = props.facetElementData.elementname
  const selected = props.facetElementData.selected
  const hitcount = props.facetElementData.hitcount
  const active = hitcount > 0

  return (
    <div data-element-name={elementname}>
      <div
        className={"flex h-full cursor-pointer justify-between"}
        onClick={(event) => {
          if (active) {
            props.handleSelect(
              props.allFacetElements,
              props.facetElementData,
              getLinkWithEncryptedFfSearchParams(
                props.query,
                props.baseCategory,
                props.brandSlug,
                props.facetElementData.encryptedFfSearchParams,
                props.sbLocale
              )
            )
          } else {
            event.preventDefault()
          }
        }}
      >
        <div className="flex flex-row items-center gap-1 hover:text-primary">
          <div
            className={cn(
              `
                flex items-center rounded-sm border border-transparent bg-secondary p-2 text-sm
                hover:border-primary hover:bg-primary hover:text-primary-foreground
              `,
              {
                "border-primary bg-primary text-primary-foreground": selected,
                "cursor-not-allowed opacity-20 hover:border-transparent hover:bg-secondary hover:text-secondary-foreground":
                  !active,
                "p-0": props.icon,
              }
            )}
          >
            {props?.icon && (
              <StoryblokAssetClient
                width={64}
                height={64}
                className={cn("size-10 rounded-sm", {
                  grayscale: !active,
                })}
                asset={props.icon}
              />
            )}
            <p
              className={cn("", {
                hidden: props.icon,
              })}
            >
              {formatFacetElementLabel(elementname, props.unit)}
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}
